export default {
  title: 'Vagues',
  actions: {
    create: 'Créer une vague',
    delete: 'Supprimer cette vague'
  },
  step: {
    create: 'Créer une step',
    edited: 'Éditer une step'
  },
  deletion: {
    message: 'Êtes-vous sûr de vouloir supprimer cette vague ?'
  },
  empty: {
    title: 'Aucune vague',
    message: 'Pour créer une vague, rien de plus simple, il suffit de cliquer sur le lien suivant :'
  },
  list: {
    name: 'nom',
    status: 'statut',
    who: 'qui',
    where: 'ou',
    when: 'quand',
    reward: 'récompense'
  }
}



// WEBPACK FOOTER //
// ./src/translations/fr/waves.js